import { type ComponentProps, useCallback } from "react";

import { useWeather, WEATHER_STATION_ID } from "@features/weather";

import { useImageMaskRef } from "@shared/hooks/use-image-mask-ref";
import { BrandIcon } from "@shared/ui/brand-icon";
import { Button } from "@shared/ui/button";
import { Icon } from "@shared/ui/icon";
import { Image } from "@shared/ui/image";
import { Body, Heading } from "@shared/ui/typography";

import type { WebCamType } from "@/_pages/web-cams/model/types";

import s from "./web-cam-card.module.scss";

export type WebCamCardProps = ComponentProps<"div"> & {
  data: WebCamType;
  onCardClick: (uid: string) => void;
};

export const WebCamCard = (props: WebCamCardProps) => {
  const {
    data: { mountainHeight, previewImage, title, inLive, uid },
    onCardClick,
  } = props;

  const handleClick = useCallback(() => {
    if (onCardClick) onCardClick(uid);
  }, [onCardClick]);

  const $imageRef = useImageMaskRef();

  const { weather } = useWeather({
    stationId: process.env.NEXT_PUBLIC_KONPID_STATION_ID || WEATHER_STATION_ID,
  });

  return (
    <article className={s.root}>
      <Button onClick={handleClick} className={s.wrapper}>
        <div className={s.top}>
          <div>
            {inLive && (
              <div className={s.live}>
                <div className={s.redDot} />
                <Body size="uppercase-small" weight="semiBold">
                  В эфире
                </Body>
              </div>
            )}
          </div>
          {/* tag="p": высота — подпись, а не заголовок раздела */}
          <Heading level={6} tag="p">
            {mountainHeight}
          </Heading>
        </div>
        <div className={s.middle} ref={$imageRef}>
          <Icon name="scan" className={s.scanIcon} />
          {previewImage?.url && (
            <Image
              src={previewImage.url}
              alt={previewImage?.alternativeText ?? "card image"}
              height="100%"
              className={s.image}
            />
          )}
        </div>
        <div className={s.bottom}>
          <Heading level={6} tag="h2" className={s.bottomTitle}>
            {title}
          </Heading>
          {/* <div className={s.weather}>
            <div className={s.weatherInfo}>
              {weather?.temperature && (
                <Heading level={5}>{weather?.temperature?.full}</Heading>
              )}
              {weather?.description && (
                <Body size="uppercase-small" weight="semiBold">
                  {weather?.description}
                </Body>
              )}
            </div>
            <div className={s.iconWrapper}>
              <BrandIcon
                name={weather?.icon || "sur"}
                fillColor="azure"
                strokeColor="white"
                className={s.icon}
              />
              <BrandIcon
                name="arrow"
                fillColor="white"
                strokeColor="azure"
                className={s.iconLink}
              />
            </div>
          </div> */}
        </div>
      </Button>
    </article>
  );
};

WebCamCard.displayName = "WebCamCard";
